import { render, staticRenderFns } from "./FetchAndEmpty.vue?vue&type=template&id=5e7a4516&scoped=true&"
import script from "./FetchAndEmpty.vue?vue&type=script&lang=js&"
export * from "./FetchAndEmpty.vue?vue&type=script&lang=js&"
import style0 from "./FetchAndEmpty.vue?vue&type=style&index=0&id=5e7a4516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a4516",
  null
  
)

export default component.exports